import { getPackagePath, getProductId } from '../services';
import AxiosClient from './AxiosClient';
import { getHeaders } from './HttpUtil';

import type { IAuthorizationRequest, ICurrencyRequest, IPriceRequest } from '../../types/IApiTypes';

export const PriceApi = {
  price: (action: IPriceRequest) => {
    const productModel = action.modelId;
    return AxiosClient.get('/product/v1/price/read', {
      params: {
        packagePath: getPackagePath(getProductId()),
        country: action.countryCode,
        currency: action.currencyCode,
        productModel: productModel,
      },
      headers: getHeaders(action.token).headers,
    })
      .then((response) => {
        return {
          price: response.data,
          modelId: productModel,
        };
      })
      .catch(() => {
        throw new Error('Failed to fetch price data');
      });
  },

  currency: (action: ICurrencyRequest) => {
    return AxiosClient.get('/product/v1/currency/read', {
      params: { packagePath: getPackagePath(getProductId()), country: action.countryCode },
      headers: getHeaders(action.token).headers,
    })
      .then((response) => {
        return {
          currency: response.data,
        };
      })
      .catch(() => {
        return null;
      });
  },

  priceListMap: (action: IAuthorizationRequest) => {
    return AxiosClient.get('/product/v1/pricelist/read', {
      params: { packagePath: getPackagePath(getProductId()) },
      headers: getHeaders(action.token).headers,
    })
      .then((response) => {
        return response.data.priceMaps;
      })
      .catch(() => {
        return null;
      });
  },
};
